import { useState } from 'react';
import { useSelector } from 'react-redux';
import { debugSentryState } from '../utils/sentry';

const SentryTestButton = () => {
	const [isVisible, setIsVisible] = useState(true);
	const { organization, user } = useSelector((state) => state.header);

	const logDebugInfo = () => {
		console.log('🔍 Redux State Debug Info:');
		console.log('  - Current URL:', window.location.pathname);
		console.log('  - Redux organization:', organization);
		console.log('  - Organization name:', organization?.name);
		console.log('  - User:', user);
		console.log('  - Environment:', import.meta.env.VITE_API_ENVIRONMENT);
		console.log(
			'  - Sentry DSN configured:',
			!!import.meta.env.VITE_SENTRY_DSN
		);

		// Also call the Sentry debug function
		debugSentryState();
	};

	// Only show in non-production environments
	if (import.meta.env.VITE_API_ENVIRONMENT === 'production') {
		return null;
	}

	if (!isVisible) {
		return (
			<button
				onClick={() => setIsVisible(true)}
				className="fixed bottom-4 right-4 z-50 bg-red-500 hover:bg-red-600 text-white p-2 rounded-full shadow-lg transition-colors duration-200"
				title="Show Sentry Test Button"
			>
				🐛
			</button>
		);
	}

	return (
		<div className="fixed bottom-4 right-4 z-50 flex flex-col gap-2">
			<button
				onClick={() => {
					throw new Error('Do it again!');
				}}
				className="bg-red-500 hover:bg-red-600 text-white px-4 py-2 rounded-lg shadow-lg transition-colors duration-200 text-sm font-medium"
			>
				Break the world
			</button>
			<button
				onClick={logDebugInfo}
				className="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded-lg shadow-lg transition-colors duration-200 text-sm font-medium"
				title="Log debug info to console"
			>
				Debug Info
			</button>
			<button
				onClick={() => setIsVisible(false)}
				className="bg-gray-500 hover:bg-gray-600 text-white px-2 py-1 rounded text-xs"
				title="Hide test button"
			>
				Hide
			</button>
		</div>
	);
};

export default SentryTestButton;
